import FeatherIcon from "feather-icons-react";
import React, {useState, useContext} from "react";
import {useTranslation} from "react-i18next";
import {LoginSocialFacebook} from "reactjs-social-login";
import axios from "axios";
import {toast} from "react-toastify";
import AuthContext from "../contexts/AuthContext";

const FacebookAuth = () => {
    const { t } = useTranslation();
    let [facebookLoader, setFacebookLoader] = useState(false);
    const { socialLoginUser } = useContext(AuthContext);

    const Auth = async (data) => {
        try {
            setFacebookLoader(true);
            const token = data.accessToken || data.access_token;
            await socialLoginUser('facebook', token);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setTimeout(() => {setFacebookLoader(false)}, 200)
        }

    }
        return <LoginSocialFacebook
            appId="190459435885969"
            // scope="openid profile email"
            discoveryDocs="clams supported"
            access_type="offline"
            fieldsProfile={
                'id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender'
            }
            isOnlyGetToken={true}
            onResolve={({ provider, data }) => {
                Auth(data);
            }}
            onReject={(err) => { console.error("Facebook Auth Reject:", err); }}
        >
          <div 
              className="facebook" 
              id="facebook-signin"
              onClickCapture={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  toast.info(t("Facebook auth in development"));
              }}
          >
              {
                  facebookLoader ?
                      <>
                          <FeatherIcon icon="loader" />
                          {t("Loading")}...
                      </>
                      :
                      <>
                          <FeatherIcon icon="facebook" />
                          <span>{t("Sign in with")} </span> {t("Facebook")}
                      </>
              }

          </div>
        </LoginSocialFacebook>
}

export default FacebookAuth